import styled, { css } from 'styled-components';
import responsive from '@/se/utilities/responsive';

// Styled components
interface PanelsStatusProps {
  $wrap?: boolean;
  $miniView?: boolean;
  $moreSpace?: boolean;
  $shrink?: boolean;
}

const PanelsStatus = styled.div<PanelsStatusProps>`
  display: flex;
  margin-left: -0.25rem;
  margin-right: -0.25rem;
  flex: 1 1 50%;

  > div {
    margin: 0.25rem;
  }

  ${responsive.sm.andSmaller`
    flex-flow: column;
  `};

  ${props =>
    props.$wrap &&
    css`
      flex-wrap: wrap;
      flex: 1 1 50%;
    `}

  ${props =>
    props.$miniView &&
    css`
      flex: 0 0 50%;
    `}

  ${props =>
    props.$moreSpace &&
    css`
      flex: 0 0 80%;
    `}

  ${props =>
    props.$shrink &&
    css`
      flex: 0 0 auto;
      align-self: stretch;
    `}
`;

export default PanelsStatus;
